import React from 'react';
import styled from 'styled-components';

import { colors, media } from '../../../core';
import Icon from '../Icon';
import Text from '../Text';

export interface BreadcrumbsProps {
  path: string[];
  onPress?: (pathName: string) => void;
}

const BreadCrumbsWrapper = styled.div`
  background-color: ${colors.white};
`;

const BreadCrumbs = styled.div`
  margin: 0 auto;
  max-width: 1440px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  ${media.tabletPortrait} {
    padding: 12px;
  }
`;

const Level = styled(Text).attrs({
  size: 'small',
})<{ active?: boolean }>`
  margin-bottom: 0;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
`;

const LevelIcon = styled(Icon)`
  margin: 0 8px;

  ${media.tabletPortrait} {
    margin: 0 4px;
  }
`;

const Link = styled.a`
  cursor: pointer;
`;

const Breadcrumbs = ({ path, onPress }: BreadcrumbsProps) => {
  const [first, ...rest] = path;

  return (
    <BreadCrumbsWrapper>
      <BreadCrumbs>
        <Link onClick={() => onPress && onPress(first)}>
          <Level>{first}</Level>
        </Link>

        {rest.map((item: string, index: number) => {
          const isActive = index === rest.length - 1;

          return (
            <React.Fragment key={index}>
              <LevelIcon type="caret-right" size={10} color={colors.ash} />

              {isActive ? (
                <Level active={isActive}>{item}</Level>
              ) : (
                <Link onClick={() => onPress && onPress(item)}>
                  <Level active={isActive}>{item}</Level>
                </Link>
              )}
            </React.Fragment>
          );
        })}
      </BreadCrumbs>
    </BreadCrumbsWrapper>
  );
};

export default Breadcrumbs;
